<template lang="pug">
	.company-selector
		Dropdown(ref="dropdown",
			v-if="dropdownVisible",
			:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a,b, {...(c || {}), byType: searchCompanyType, forceTokenAuth }, forceTokenAuth !== null ? $auth.countryId() : null)",
			:columns="[{ dataField: 'Name', caption: $tCaption('Company') }]",
			displayExpr="Name",
			valueExpr="Oid",
			:placeholder="placeholder || `${$tCaption('Find')} ${orgTypeName.toLowerCase()}`",
			:selectedItems="innerValue",
			:showColumnHeaders="false",
			:filtersVisible="false",
			:searchVisible="true",
			:multiple="!!multiple",
			:minSearchLength="!isGlobalSearch ? 0 : minSearchLength",
			:disabled="disabled",
			:noDataText="!isGlobalSearch ? $tCaption('No data', '@actions') : $tCaption('Type at least 3 characters', '@actions')",
			@select-data="v => processSelect(v)",
			@search="companySearched = true; companyNotFound = false",
			@data-loaded="(data) => { companyNotFound = !data || !data.length; isDataLoaded = true; }")
			.flex-row.space.align-center(v-if="isDataLoaded && !isGlobalSearch", slot="bottom")
				span {{$tCaption(`Can't find an`, 'TryDirectory')}} {{orgTypeName.toLowerCase()}}? {{$tCaption('Try our', 'TryDirectory')}}
				a(@click="searchInDirectory") {{directoryName}} {{$tCaption('Directory', 'TryDirectory')}}
			.flex-row.center.align-center(v-if="!isDataLoaded", slot="bottom")
				Loader()
		Popup(v-if="inviteContactForCompanyPopupVisible", :popupVisible="inviteContactForCompanyPopupVisible", :width="320", :height="220", title="Invite contact", @hiding="() => { inviteContactForCompany = null; doneSelect(); }")
			DxTextBox(placeholder="Email", :value.sync="inviteContactForCompanyEmail", valueChangeEvent="input")
			template(slot="actions-right")
				DxButton(text="Invite", type="success", @click="inviteContact", :disabled="invitingContact || !$Data.validateEmail(inviteContactForCompanyEmail)")
				DxButton(text="Close", @click="() => { inviteContactForCompany = null; doneSelect(); inviteContactForCompanyPopupVisible = false; }")
</template>

<script>
	import Dropdown from 'app-core/Dropdown.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import VueTypes from 'vue-types';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'company.CompanySelector',
		name: 'company-selector',
		props: {
			value: VueTypes.any.def(null),
			companyType: VueTypes.oneOf([0,1,2]).def(0),
			multiple: VueTypes.bool.def(false),
			minSearchLength: VueTypes.number.def(3),
			disabled: VueTypes.bool.def(false),
			placeholder: VueTypes.string.def(null),
			dropdownVisible: VueTypes.bool.def(true)
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		components: {
			Dropdown, Popup, DxTextBox, DxButton, Loader
		},		
		data() {
			return {
				innerValue: this.value,
				companyNotFound: false,
				companySearched: false,
				forceTokenAuth: null,
				inviteContactForCompany: null,
				inviteContactForCompanyEmail: null,
				inviteContactForCompanyPopupVisible: false,
				invitingContact: false,
				isDataLoaded: false,
				selectedCompany: null,
				selectionDone: false
			};
		},
		computed: {
			searchCompanyType() {
				return this.companyType !== null ? this.companyType : this.$auth.company().CompanyType;
			},
			directoryName() {
				return [this.$tCaption('Advertisers'), this.$tCaption('Station owners'), this.$tCaption('Agencies')][this.searchCompanyType];
			},
			orgTypeName() {
				return [this.$tCaption('advertiser'), this.$tCaption('station owner'), this.$tCaption('agency')][this.searchCompanyType];
			},
			isGlobalSearch() {
				return this.forceTokenAuth !== null;
			}
		},
		watch: {
			innerValue(v) {
				this.$emit('change', v);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.companySelector = this;
		},			
		methods: {
			inviteContact() {
				this.invitingContact = true;
				this.$emit('inviting');
				this.$Data.getExternalApi('Company/InviteRegisteredCompany', `companyId=${this.inviteContactForCompany}&contactEmail=${this.inviteContactForCompanyEmail}`, {}).then(r => {
					if (r && r.ErrorMessage) {
						this.$notifyError(r.ErrorMessage);
						this.$emit('invited', false);
					} else {
						this.$notifySuccess(this.$tCaption('Invite has been successfully sent'));
						this.$emit('invited', true);
					}
				})
				.catch(() => this.$emit('invited', false))
				.finally(() => this.doneSelect());
			},
			searchInDirectory() {
				this.forceTokenAuth = false;
				this.$refs.dropdown.reload();
			},
			doneSelect() {
				if (__DEBUG__)
					console.debug('Company selected', { c : this.selectedCompany });
				if (this.selectionDone) return;
				this.inviteContactForCompanyPopupVisible = false;
				this.$emit('change', this.innerValue);
				this.$emit('select-data', this.selectedCompany);
				this.selectionDone = true;
				this.forceTokenAuth = null;
			},
			inviteContactToCompany(company) {
				this.inviteContactForCompany = company.Oid;
				this.inviteContactForCompanyPopupVisible = true;
			},
			processSelect(item, forceConfirmation) {
				this.selectedCompany = item;
				this.selectionDone = false;

				if (!item) return Promise.reject('Canceled');

				return new Promise((resolve, reject) => {
					var doSelect = () => {
						this.inviteContactForCompany = null;
						this.inviteContactForCompanyEmail = null;
						this.$Data.getExternalApi('Company/LinkCompanyToCurrentUser', `companyId=${item.Oid}`, {}).then(r => {
							if ((this.isGlobalSearch || forceConfirmation) && !item.IsUserAssigned) {
								this.inviteContactForCompanyPopupVisible = false;
								this.$confirmMessage({
									title: this.$tCaption('Contact invitation'),
									text: `<b>${item.Name}</b> ${this.$tCaption('doesn’t have any registered contacts on the Adthos platform. Would you like to invite a contact at')} <b>${item.Name}</b>?<br><br>${this.$tCaption('You can always invite a contact from the organization menu at a later point in time.')}`,
									buttons: [{
										type: 'success',
										text: this.$tCaption('Invite contact'),
										onClick: () => {
											this.inviteContactToCompany(item);
											resolve();
										}
									}, {
										text: this.$tCaption('Skip'),
										onClick: () => {
											this.doneSelect();
											resolve();
										}
									}]
								});
							} else {
								this.doneSelect();
								resolve();
							}
						});
					};

					if (this.multiple) {
						if (item)
							this.innerValue.push(item.Oid);
					} else {
						this.innerValue = item && item.Oid || null
					};

					if (!this.isGlobalSearch && !forceConfirmation) 
					{
						doSelect();
					} else {
						this.$confirmMessage({
							title: this.$tCaption('Confirm action'),
							text: this.$tCaption('Do you want to link the selected company? This will grant access to the Company’s data.'),
							handler: () => {
								doSelect();
							},
							cancel: () => {
								this.innerValue = this.value;
								reject('Canceled');
							}
						});
					}

					return null;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.company-selector {
		
	}
</style>
 